import React from 'react';
export function StickyAlertBar() {
  const message = '🔥 SOLO POR HOY + BONOS EXCLUSIVOS 🔥';
  // Two identical groups side-by-side. When group 1 scrolls out left,
  // group 2 is already in its place — translateX(-50%) resets seamlessly.
  const items = Array(6).fill(message);
  return <div className="fixed top-0 left-0 w-full z-50 bg-dark text-gold-400 h-10 flex items-center overflow-hidden border-b border-gold-500/30 shadow-md" data-id="element-290">
      <div className="animate-marquee flex shrink-0 items-center whitespace-nowrap" data-id="element-291">
        {/* Group 1 */}
        {items.map((text, i) => <span key={`a-${i}`} className="font-bold text-sm tracking-widest uppercase mx-6" data-id="element-292">
            {text}
          </span>)}
        {/* Group 2 — identical duplicate for seamless loop */}
        {items.map((text, i) => <span key={`b-${i}`} className="font-bold text-sm tracking-widest uppercase mx-6" data-id="element-293">
            {text}
          </span>)}
      </div>
    </div>;
}